import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
<animated.div
        class="card8"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_6.jpg")' }}    
/> 

</div>*/

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }

  return (
    <div className="">

       

        <div   id = "signal-report"    className="card-8"  style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
        <br></br>

          <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Instrument Tracker & Reporting System</span></a>
                           
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">
                  <span>Our Financial Instruments Tracker and Reporting System ( for US stocks, CFDs and Cryptocurrencies )  is a comprehensive cloud-based market intelligence and reporting platform designed to centralize real-time monitoring, analytical visualization, signal tracking, and trading-performance reporting within a unified ecosystem.</span>
                  <span>The platform delivers interactive market visibility through streaming data infrastructure, structured reporting engines, and real-time analytical workflows optimized for both monitoring and backtesting operations.</span>
                  
                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>

                  <br></br>  
                  
                  </p>

                <br></br>  

        </div>

        <br></br>

        

</div>

  )
};

export default Card; 